<!-- 上传 -->
<template>
  <div id="zlr-upload">
    <div v-if="lineSelectable" style="margin-bottom: 12px">
      <div style="color: #999999; font-size: 12px; margin-bottom: 4px">如果您现在在中国国内，推荐使用中国线路。如果在其他国家或地区推荐使用国际线路</div>
      <Button style="width: 150px" :class="line === 'China' ? ['border'] : []" class="close-btn" @click="selectLine('China')">中国线路</Button>
      <Button style="width: 150px; margin-left: 12px" :class="line === 'i18n' ? ['border'] : []" class="close-btn" @click="selectLine('i18n')">国际线路</Button>
    </div>
    <Upload ref="upload"
            type="drag"
            :action="uploadProfile[profile] + '/file/system/upload'"
            :before-upload="handleUpload"
            :data="uploadParams"
            :on-success="onUploadSuccess"
            :class="{error:!!errorMsg}">
      <slot name='content'>
        <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload"
                size="52"
                style="color: #3399ff"></Icon>
          <p>点击或拖动文件到此处上传</p>
        </div>
      </slot>
    </Upload>
    <div v-if="line === 'China'">
      <div v-if="imgName || errorMsg"
           class="up-content">
        <p class="up-error"
           v-show="!!errorMsg">{{errorMsg}}</p>
        <p class="up-name"
           v-show="!!imgName">{{ imgName }}</p>
        <div class="up-progress-slot"
             v-show="progress>0&&progress<1">
          <div class="up-close"
               @click="stopUplod">
            <Icon type="ios-close-circle"
                  size="16" />
          </div>
          <div class="up-progress"
               :style="{width: progress*100+'%'}"></div>
        </div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
// api
import { ossSecret, ossOpen } from '@/api/oss'
import { randomString } from '@/libs/tools'
import profile from '_conf/env'
import { mapState } from 'vuex'

export default {
  name: 'zlr-upload',
  // path: 是上传文件的路径
  // randomLength 文件名是否是随机数 如果大于0 就是根据定义的长度取随机名的长度
  // format 是否需要校验格式
  props: {
    errorInfo: {
      type: String,
      default: ''
    },
    value: {
      default: ''
    },
    path: {
      type: [String],
      required: true
    },
    randomLength: {
      type: [Number],
      default: 0
    },
    // Mb
    size: {
      type: [Number]
    },
    format: {
      type: [Array],
      default () {
        return []
      }
    },
    secret: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data () {
    return {
      profile: profile,
      errorMsg: '',
      imgName: '',
      progress: 0,
      client: '',
      uploadParams: {},
      lineSelectable: true,
      line: 'China',
      // TODO 2019-10-15 phy 临时方案
      uploadProfile: {
        production: 'https://mentorapi.zailairen.com',
        development: 'https://mo-qa-api.zailairen.com',
        qa: 'https://mo-qa-api.zailairen.com',
        cu: 'https://localhost:27100'
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => {
        return state.user.userInfo
      }
    })
  },
  mounted () {

  },
  methods: {
    setInit () {
      this.errorMsg = ''
      this.imgName = ''
      this.$emit('input', '')
    },
    handleUpload (file) {
      this.setInit()
      this.file = file
      let type = file.name.substring(file.name.lastIndexOf('.') + 1)
      let format = this.format
      // 判断格式
      if (format.length > 0 && !format.includes(type)) {
        let msg = this.errorInfo || ('请上传图片格式:' + format.join(','))
        this.$emit('on-error', msg)
        this.errorMsg = msg
        return true
      }
      // 判断大小
      if (this.size && file.size > this.size * 1024 * 1024) {
        let msg = '上传文件过大'
        this.$emit('on-error', msg)
        this.errorMsg = msg
        return false
      }
      // 判断文件名字是否含有+
      if (file.name.indexOf('+') !== -1) {
        let msg = '上传文件名不能包含特殊符号'
        this.$emit('on-error', msg)
        this.errorMsg = msg
        return false
      }
      let data = {
        dir: this.path
      }
      this.imgName = file.name
      if (this.line === 'i18n') {
        return this.buildUploadParams(file)
      } else {
        this.uploadType(data).then(res => {
          this.getUpImg(res.data, file)
        })
        return false
      }
    },
    uploadType (data) {
      return new Promise(resolve => {
        if (this.secret) {
          ossSecret(data).then(res => {
            resolve(res)
          })
        } else {
          ossOpen(data).then(res => {
            resolve(res)
          })
        }
      })
    },
    buildUploadParams (file) {
      this.$refs['upload'].clearFiles()
      if (this.randomLength) {
        this.uploadParams.filename = randomString(this.randomLength)
      } else {
        this.uploadParams.filename = file.name
      }
      let num = this.userInfo.num
      console.log(num)
      this.uploadParams.targetDirPath = `/docs/${profile}/mentor/${num}/${new Date().getTime()}`.replace(/\/$/g, '') + '/' + this.path
      this.uploadParams.bucket = this.secret ? 'ZLR_SP_PRIVATE' : 'ZLR_VALEON_OM'
      this.imgName = file.name
      return true
    },
    getUpImg (a, f) {
      let name = f.name.replace(/\//g, '-')
      this.client = new OSS.Wrapper({
        region: 'oss-cn-beijing',
        accessKeyId: a.accessid,
        secure: true,
        endpoint: a.endpoint,
        accessKeySecret: a.accessKey,
        bucket: a.bucket
      })
      let the = this
      this.client.multipartUpload(a.dir + '/' + name, f, {
        progress: async function (p, checkpoint) {
          the.progress = p
        }
      }).then(res => {
        this.$emit('on-success', f)
        if (this.secret) {
          the.$emit('input', res.name)
        } else {
          the.$emit('input', `https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/${res.name}`)
        }
      })
    },
    // 停止上传
    stopUplod () {
      if (this.client) {
        this.client.cancel()
      }
      this.imgName = ''
    },
    selectLine (line) {
      this.line = line
    },
    onUploadSuccess (res) {
      console.log(res)
      console.log(this.file)
      this.$emit('on-success', this.file)
      if (this.secret) {
        this.$emit('input', res.data.model.objectKey)
      } else {
        this.$emit('input', res.data.model.url)
        this.url = res.data.model.url
      }
    }
  },
  watch: {
  }
}
</script>
<style lang='less' scoped>
.up-error {
  color: red;
  line-height: 24px;
}
.up-name {
  margin-bottom: 12px;
}
.up-progress-slot {
  width: 100%;
  height: 4px;
  position: relative;
  background: #f0f0f0;
}
.up-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  background: @c-primary;
}
.up-content {
  position: relative;
}
.up-close {
  position: absolute;
  right: 0;
  top: -26px;
  cursor: pointer;
}
</style>
<style lang='less'>
#zlr-upload {
  .error {
    .ivu-upload-drag {
      border: 1px solid red;
    }
  }
}
.border {
  border: 1px solid #348EED;
}
</style>
